// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"33":"2f5dedadbd5220a9","620":"d0fe4cc3d2aab552"}[chunkId] + ".js";
};